// POST

import axios, { AxiosResponse } from 'axios';
import { CreateWelfareFieldCollectionInput } from 'views/fish-check/features/welfare-scoring/types/create-welfare-field-collection-input.type';

// /ewosapi/v1/fieldregistration/fieldcollection/{fieldCollectionId}/welfare
export const postFieldCollectionWelfare = async (
  fieldCollectionId: number,
  request: CreateWelfareFieldCollectionInput
): Promise<AxiosResponse> => {
  return await axios.post<AxiosResponse>(`/ewosapi/v1/fieldregistration/fieldcollection/${fieldCollectionId}/welfare`, [request]);
};
